export default "__VITE_ASSET__CYxGyO5w__"